var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.offerID > 0)?_c('div',[_c('offerEdit',{attrs:{"id-selected-offer":_vm.offerID,"from-add-to-offer":true}})],1):_c('div',[_c('b',[_vm._v(" "+_vm._s(_vm.uniTranslation("PHE2233")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }